import styled, {css} from 'styled-components';
import {mediaMinTablet} from '../../../constants/customMedia';

export const Container = styled.section<{
  backgroundImage?: string;
  variant: 'light' | 'dark';
  minHeight?: number;
  isFullwidth?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${({backgroundImage}) => backgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  color: ${({variant}) => (variant === 'dark' ? '#000' : '#fff')};
  border-radius: 4px;
  margin-top: 120px;
  margin-bottom: 120px;
  padding-left: 24px;
  padding-right: 24px;
  position: relative;

  @media ${mediaMinTablet} {
    padding-left: 0;
    padding-right: 0;
  }

  ${({minHeight}) =>
    minHeight &&
    css`
      min-height: ${minHeight}px;
    `}

  ${({isFullwidth}) =>
    isFullwidth &&
    css`
      margin-left: -10px;
      margin-right: -10px;

      @media ${mediaMinTablet} {
        margin-left: 0;
        margin-right: 0;
      }
    `}
`;
